export default __webpack_public_path__ + "static/media/Pilgrim's Helm of the Crumbling Tower.b0a27248.jpg";